import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-row tw-items-center"
}
const _hoisted_2 = {
  key: 0,
  class: "header tw-flex tw-items-center"
}
const _hoisted_3 = { class: "tw-rounded tw-rounded-full tw-flex tw-items-center" }
const _hoisted_4 = ["data"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tw-text-sm md:tw-text-md tw-font-bold tw-text-slate-700" }
const _hoisted_7 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-700 tw-mb-1 ellipsis tw-w-full"
}
const _hoisted_8 = { class: "tw-flex tw-flex-row" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "tw-ml-2" }
const _hoisted_11 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_12 = {
  key: 0,
  class: "tw-pb-4 md:tw-pb-4"
}
const _hoisted_13 = { class: "tw-border tw-border-solid tw-border-[#0000001f] tw-rounded tw-p-4" }
const _hoisted_14 = { class: "tw-flex" }
const _hoisted_15 = { class: "tw-w-1/2" }
const _hoisted_16 = { class: "tw-flex tw-flex-col" }
const _hoisted_17 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_18 = { class: "tw-flex tw-flex-col tw-mt-4" }
const _hoisted_19 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_20 = { class: "tw-flex tw-flex-col tw-mt-4" }
const _hoisted_21 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_22 = { class: "tw-w-1/2" }
const _hoisted_23 = { class: "tw-flex tw-flex-col" }
const _hoisted_24 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_25 = { class: "tw-flex tw-flex-col tw-mt-4" }
const _hoisted_26 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_27 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-mt-4"
}
const _hoisted_28 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_29 = {
  key: 1,
  class: "tw-border tw-border-solid tw-border-[#0000001f] tw-rounded tw-mt-4 tw-p-2 md:tw-p-6"
}
const _hoisted_30 = { class: "tw-flex" }
const _hoisted_31 = { class: "tw-w-1/2" }
const _hoisted_32 = { class: "tw-flex tw-flex-col" }
const _hoisted_33 = { class: "tw-text-sm tw-mt-[1px]" }
const _hoisted_34 = { class: "tw-w-1/2" }
const _hoisted_35 = { class: "tw-flex tw-flex-col" }
const _hoisted_36 = { class: "tw-text-sm tw-mt-[1px]" }

import { computed, PropType } from 'vue';
    
    import { useCurrencyFormatter, useSanitiseReg, useScreenSize } from 'src/functions';
    import type { Vehicle } from 'src/types/loan-application';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleInfo',
  props: {
        vehicle: {
            type: Object as PropType<Vehicle>,
            default: null
        },
        large: {
            type: Boolean,
            default: false
        },
        hideImage: {    
            type: Boolean,
            default: false
        }
    },
  setup(__props) {

    const props = __props

    const screen = useScreenSize();

    const imgSrc = computed(() => {
        if(props.vehicle && props.vehicle.image && props.vehicle.image.indexOf('null') === -1){
            return props.vehicle.image;
        }
        return require('assets/img/no-image.png');
    })

return (_ctx: any,_cache: any) => {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_ImageCarousel = _resolveComponent("ImageCarousel")!

  return (!__props.large)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!__props.hideImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock("object", {
                  data: imgSrc.value,
                  key: __props.vehicle.vrm,
                  type: "image/png",
                  class: "tw-w-[72px] tw-h-[72px] tw-rounded-full tw-mx-auto tw-object-cover"
                }, [
                  _createElementVNode("img", {
                    src: require('assets/img/no-image.png'),
                    alt: "Vehicle Image",
                    class: "tw-w-[72px] tw-h-[72px] tw-rounded-full tw-mx-auto tw-object-cover"
                  }, null, 8, _hoisted_5)
                ], 8, _hoisted_4))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["content tw-overflow-hidden", !__props.hideImage ? 'tw-pl-4' : ''])
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.vehicle.make) + " " + _toDisplayString(__props.vehicle.model), 1),
          (__props.vehicle.trim)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.vehicle.trim), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Badge, {
                label: _unref(useSanitiseReg)(__props.vehicle.vrm),
                bgColour: "tw-bg-slate-200",
                "text-size": "tw-text-xs"
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Badge, {
                label: __props.vehicle.mileage.toLocaleString() + ' miles',
                bgColour: "tw-bg-slate-200",
                "text-size": "tw-text-xs"
              }, null, 8, ["label"])
            ])
          ])
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        (__props.vehicle.images)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_ImageCarousel, {
                images: __props.vehicle.images,
                height: _unref(screen).lte('lg') ? 230 : 280
              }, null, 8, ["images", "height"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "VRM", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(useSanitiseReg)(__props.vehicle.vrm)), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "Mileage", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(__props.vehicle.mileage.toLocaleString()) + " mi", 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "Fuel Type", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(__props.vehicle.fuel ?? 'Unknown'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "Year", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(__props.vehicle.year ?? new Date(__props.vehicle.vehicleDateOfFirstReg ?? __props.vehicle.registrationDate).getFullYear()), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "Transmission", -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString(__props.vehicle.transmission), 1)
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "tw-text-sm tw-font-bold" }, "ULEZ Compliant", -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(__props.vehicle.ulez === true ? 'Yes' : __props.vehicle.ulez === false ? 'No' : 'Unknown'), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold" }, "Insurance Group", -1)),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(__props.vehicle.insuranceGroup ?? 'Unknown'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold" }, "Tax Per Year", -1)),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(__props.vehicle.taxPerYear ? _unref(useCurrencyFormatter)(__props.vehicle.taxPerYear) : 'Unknown'), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})